"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _createStyled = require("../../../utils/createStyled");

var _prepareOptionContent = _interopRequireDefault(require("../utils/prepareOptionContent"));

var _ClickAwayListener = _interopRequireDefault(require("../../ClickAwayListener"));

var _listOverlay = _interopRequireDefault(require("../views/listOverlay.c"));

var _option = _interopRequireDefault(require("../views/option.c"));

var _reactTinyVirtualList = _interopRequireDefault(require("react-tiny-virtual-list"));

var _border = _interopRequireDefault(require("../views/border.c"));

var _label = _interopRequireDefault(require("../views/label.c"));

var virtualListRender = function virtualListRender(props) {
  return _react["default"].createElement(_reactTinyVirtualList["default"], props);
},
    getOptionsRender = function getOptionsRender(defaultProps) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$list = options.list,
        list = _options$list === void 0 ? defaultProps.list : _options$list,
        _options$maxLength = options.maxLength,
        maxLength = _options$maxLength === void 0 ? defaultProps.maxLength : _options$maxLength,
        _options$itemSize = options.itemSize,
        itemSize = _options$itemSize === void 0 ? defaultProps.itemSize : _options$itemSize,
        _options$virtualized = options.virtualized,
        virtualized = _options$virtualized === void 0 ? defaultProps.virtualized : _options$virtualized,
        _options$listRef = options.listRef,
        listRef = _options$listRef === void 0 ? defaultProps.listRef : _options$listRef,
        _options$style = options.style,
        style = _options$style === void 0 ? defaultProps.style : _options$style;
    var content = null;

    if (virtualized) {
      var height = list.length > maxLength ? itemSize * maxLength : itemSize * list.length;
      content = virtualListRender({
        height: height,
        itemSize: itemSize,
        itemCount: list.length,
        renderItem: function renderItem(_ref) {
          var index = _ref.index,
              rest = (0, _objectWithoutProperties2["default"])(_ref, ["index"]);
          return list[index].render(rest);
        }
      });
    } else {
      content = list.map(function (option) {
        return option.render();
      });
    }

    return _react["default"].createElement(_createStyled.Styled.Div, {
      styles: style,
      ref: listRef
    }, content);
  };
};

function template() {
  var _this = this,
      _value;

  var styles = this.compileStyled(_index["default"]),
      _this$props = this.props,
      placeholder = _this$props.placeholder,
      emptyListPlaceholder = _this$props.emptyListPlaceholder,
      attribute = _this$props.attribute,
      className = _this$props.className,
      theme = _this$props.theme,
      style = _this$props.style,
      selectRender = _this$props.selectRender,
      listRender = _this$props.listRender,
      error = _this$props.error,
      disabled = _this$props.disabled,
      readOnly = _this$props.readOnly,
      maxLength = _this$props.maxLength,
      virtualized = _this$props.virtualized,
      multiple = _this$props.multiple,
      multipleSeparator = _this$props.multipleSeparator,
      _this$state = this.state,
      active = _this$state.active,
      list = _this$state.list,
      hover = _this$state.hover,
      selected = this._getSelected();

  var value,
      placeholderContent,
      listOptions = [];

  if (selected) {
    if (multiple) {
      var multipleValue = selected.map(function (item) {
        return (0, _prepareOptionContent["default"])(item, {
          isSelected: false,
          isSelectItem: true
        });
      }).filter(function (item) {
        return !!item.content;
      });
      value = {
        title: multipleValue.map(function (item) {
          return item.title;
        }).join(multipleSeparator),
        content: _react["default"].createElement(_createStyled.Styled.Div, {
          styles: styles.multipleValueWrapper
        }, multipleValue.map(function (item, i) {
          return _react["default"].createElement(_react["default"].Fragment, {
            key: item.id
          }, item.content, i < multipleValue.length - 1 ? multipleSeparator : null);
        }))
      };
    } else {
      value = (0, _prepareOptionContent["default"])(selected, {
        isSelected: false,
        isSelectItem: true
      });
    }
  }

  if (list && list.length) {
    placeholderContent = _l10n["default"].translate(placeholder);
  } else {
    placeholderContent = _l10n["default"].translate(emptyListPlaceholder);
  }

  if (list) {
    listOptions = list.map(function (item) {
      var isSelected = false;

      if (selected) {
        isSelected = multiple ? selected.includes(item) : item.id === selected.id;
      }

      var _prepareOption = (0, _prepareOptionContent["default"])(item, {
        isSelected: isSelected,
        isSelectItem: false
      }),
          content = _prepareOption.content,
          title = _prepareOption.title;

      return {
        id: item.id,
        content: content,
        title: title,
        isSelected: isSelected,
        // optionProps from react-virtual-list
        render: function render() {
          var optionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _optionProps$Componen = optionProps.Component,
              Component = _optionProps$Componen === void 0 ? _option["default"] : _optionProps$Componen,
              _optionProps$children = optionProps.children,
              children = _optionProps$children === void 0 ? _react["default"].createElement("span", null, content) : _optionProps$children;
          return _react["default"].createElement(Component, (0, _extends2["default"])({
            title: title,
            key: item.id,
            onClick: _this.select,
            id: item.id,
            onKeyDown: _this._keymap,
            onBlur: _this._handleBlur,
            qaNode: attribute + '-option',
            qaValue: title,
            theme: theme,
            isSelected: isSelected,
            multiple: multiple
          }, optionProps), children);
        }
      };
    });
  }

  return _react["default"].createElement(_createStyled.Styled.Div, {
    className: className,
    styles: styles.root,
    ref: this._rootRef,
    onMouseEnter: this._handleHover,
    onMouseLeave: this._handleRootBlur
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.wrapper
  }, active ? _react["default"].createElement(_ClickAwayListener["default"], {
    node: this.root,
    onClickAway: this.close
  }) : null, _react["default"].createElement(_label["default"], (0, _extends2["default"])({}, this.props, {
    active: active,
    hover: hover
  })), _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.input
  }, typeof selectRender === 'function' ? selectRender({
    open: this.open,
    select: this.select,
    close: this.close,
    focus: this.focusList,
    title: value ? value.title : '',
    icon: style && style.appearance || theme && theme.appearance,
    forwardedRef: this.nativeElement,
    qaNode: attribute,
    qaValue: value ? value.title : '',
    value: (_value = value) === null || _value === void 0 ? void 0 : _value.content,
    selected: !!selected,
    list: listOptions,
    active: active,
    error: error,
    hover: hover,
    disabled: disabled,
    readOnly: readOnly,
    theme: theme,
    placeholder: placeholderContent
  }) : null, _react["default"].createElement(_listOverlay["default"], {
    active: active,
    zIndex: styles.list.zIndex,
    minWidth: styles.list.minWidth,
    offsetTop: theme.listOffsetTop,
    offsetRight: theme.listOffsetRight,
    offsetBottom: theme.listOffsetBottom,
    offsetLeft: theme.listOffsetLeft,
    gapTop: theme.listGapTop,
    gapRight: theme.listGapRight,
    gapBottom: theme.listGapBottom,
    gapLeft: theme.listGapLeft
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.overlay,
    tabIndex: "0",
    "data-qa-node": attribute + '-list'
  }, typeof listRender === 'function' ? listRender({
    open: this.open,
    select: this.select,
    close: this.close,
    focus: this.focusList,
    maxLength: maxLength,
    emptyListPlaceholder: _l10n["default"].translate(emptyListPlaceholder),
    error: error,
    theme: theme,
    style: styles.list,
    list: listOptions,
    listRef: this.listElement,
    render: getOptionsRender({
      list: listOptions,
      maxLength: maxLength,
      itemSize: styles.option.height,
      virtualized: virtualized,
      listRef: this.listElement,
      style: styles.list
    }),
    virtualized: virtualized,
    virtualListRender: virtualListRender
  }) : null))), _react["default"].createElement(_border["default"], (0, _extends2["default"])({}, this.props, {
    active: active,
    hover: hover
  }))));
}